<template>
  <div
    class="relative w-full overflow-hidden h-[350px] sm:h-[400px] md:h-[450px] lg:h-[500px]"
  >
    <!-- 背景图 -->
    <div
      class="absolute inset-0 bg-cover bg-center"
      style="
        background-image: linear-gradient(
            rgba(0, 0, 0, 0.4),
            rgba(0, 0, 0, 0.4)
          ),
          url(https://pic.rmb.bdstatic.com/bjh/0749db295baab74f66d5612937da98f6.jpeg);
      "
    >
      <!-- 顶部导航栏 -->
      <nav class="relative z-20 px-4 sm:px-6 py-3 sm:py-4">
        <div class="flex items-center justify-between max-w-7xl mx-auto">
          <!-- Logo -->
          <router-link
            to="/"
            class="font-airstrip text-white no-underline text-lg sm:text-xl hover:opacity-80 transition-opacity"
          >
            hlly1
          </router-link>

          <!-- 导航按钮 -->
          <div class="flex items-center gap-2 sm:gap-3">
            <router-link
              to="/"
              class="px-3 sm:px-5 py-1.5 sm:py-2 rounded-full text-white text-xs sm:text-sm no-underline transition-all hover:scale-105 hover:shadow-lg"
              style="background-color: #8a2be2"
            >
              Home
            </router-link>

            <div class="relative group">
              <button
                class="px-3 sm:px-5 py-1.5 sm:py-2 rounded-full text-white text-xs sm:text-sm transition-all hover:scale-105 hover:shadow-lg bg-red-500"
              >
                Articles <span class="ml-1 text-xs">▼</span>
              </button>
              <div
                class="absolute hidden group-hover:block top-full mt-2 right-0 bg-white rounded-lg shadow-xl py-2 min-w-[140px] sm:min-w-[160px] z-30"
              >
                <div
                  class="px-4 py-2 text-gray-700 text-xs sm:text-sm hover:bg-gray-100 cursor-pointer"
                >
                  Constructing...
                </div>
                <div
                  class="px-4 py-2 text-gray-700 text-xs sm:text-sm hover:bg-gray-100 cursor-pointer"
                >
                  Constructing...
                </div>
              </div>
            </div>

            <router-link
              to="/"
              class="px-3 sm:px-5 py-1.5 sm:py-2 rounded-full text-white text-xs sm:text-sm no-underline transition-all hover:scale-105 hover:shadow-lg"
              style="background-color: #ff69b4"
            >
              About Me
            </router-link>
          </div>
        </div>
      </nav>

      <!-- 中央大标题 -->
      <div
        class="absolute inset-0 flex flex-col items-center justify-center z-10 px-4"
      >
        <h1
          class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white text-center mb-2 sm:mb-4 drop-shadow-2xl"
        >
          Stay Simple, Stay Naive
        </h1>
        <p class="text-white text-sm sm:text-base md:text-lg opacity-90">
          这是坠吼的~
        </p>
      </div>

      <!-- Wave 组件 - 固定在底部 -->
      <div class="absolute bottom-0 left-0 right-0 h-32 sm:h-40 md:h-48 z-15">
        <Wave />
      </div>
    </div>
  </div>
</template>

<script>
import Wave from "@/components/wave.vue";

export default {
  name: "Nav",
  components: {
    Wave,
  },
};
</script>
